import axios from "axios";

export interface OverrideRegYearParams {
  transactionId: number;
  regulatoryYear: number;
  comment: string;
}

export const overrideRegYear = (params: OverrideRegYearParams) =>
  axios.patch("transactions/overrideRegulatoryYear", params).then(({ data }) => data);
